import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { parameterizablePasswordOrAKVtoSecretBase, parameterizableSecretBaseToModel } from 'app/model/adapters/linkedservices/azure-key-vault.util';
import { ValueAdapter } from '../value.adapter';
import { serviceNowAuthTypes, ServiceNowV2LinkedService } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ServiceNowV2LinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                endpoint: '*',
                authenticationType: '*',
                username: '*',
                password: 'secret',
                clientId: '*',
                clientSecret: 'secret',
                encryptedCredential: '*',
                grantType: '*'
            },
            parameters: '*'
        }
    }
})
export class ServiceNowV2LinkedServiceAdapter extends LinkedServiceAdapter<ServiceNowV2LinkedService> {
    protected supportFirstClassParameterExperience = true;

    protected modelConstructor(): new () => ServiceNowV2LinkedService {
        return ServiceNowV2LinkedService;
    }

    protected model(): IModel {
        return ServiceNowV2LinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: ServiceNowV2LinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.ServiceNowV2LinkedService;
        properties.type = Metamodel.modelFor(ServiceNowV2LinkedService).name;
        properties.typeProperties = {
            endpoint: this.valueToResource(linkedService, ServiceNowV2LinkedService.ENDPOINT),
            authenticationType: linkedService.authenticationType,
            username: this.valueToResource(linkedService, ServiceNowV2LinkedService.USERNAME),
            password: parameterizablePasswordOrAKVtoSecretBase(linkedService, ServiceNowV2LinkedService.PASSWORD, this.context),
            clientId: linkedService.authenticationType === serviceNowAuthTypes.OAuth2 ?
                this.valueToResource(linkedService, ServiceNowV2LinkedService.CLIENT_ID) : undefined,
            clientSecret: linkedService.authenticationType === serviceNowAuthTypes.OAuth2 && linkedService.clientSecret ?
                parameterizablePasswordOrAKVtoSecretBase(linkedService, ServiceNowV2LinkedService.CLIENT_SECRET, this.context) : undefined,
            grantType: linkedService.authenticationType === serviceNowAuthTypes.OAuth2 ? 'password' : undefined
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: ServiceNowV2LinkedService): Promise<ServiceNowV2LinkedService> {
        const properties = linkedServiceResource.properties as Model.ServiceNowV2LinkedService;
        const typeProperties: Model.ServiceNowV2LinkedServiceTypeProperties = properties.typeProperties;

        ValueAdapter.toModel(linkedService, ServiceNowV2LinkedService.ENDPOINT, typeProperties.endpoint);
        linkedService.authenticationType = typeProperties.authenticationType;
        ValueAdapter.toModel(linkedService, ServiceNowV2LinkedService.USERNAME, typeProperties.username);
        parameterizableSecretBaseToModel(
            linkedService,
            ServiceNowV2LinkedService.PASSWORD,
            properties.typeProperties.password, this.context
        );

        if (typeProperties.authenticationType === serviceNowAuthTypes.OAuth2) {
            linkedService.grantType = typeProperties.grantType;
            ValueAdapter.toModel(linkedService, ServiceNowV2LinkedService.CLIENT_ID, typeProperties.clientId);
            parameterizableSecretBaseToModel(
                linkedService,
                ServiceNowV2LinkedService.CLIENT_SECRET,
                properties.typeProperties.clientSecret, this.context
            );
        }

        return linkedService;
    }
}
